var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleConditionReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Vehicle Condition Report Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Condition__Report",
    "data-name": "Vehicle_Condition_Report"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.93,0a1,1,0,0,0-1,1V8.78c-.64,0-1.29,0-1.92,0A68.71,68.71,0,0,0,12.68,9.86,1.81,1.81,0,0,0,11.29,11L7.07,19.18a6.13,6.13,0,0,0-.32-1.26,1,1,0,0,0-.89-.61H1.31a1,1,0,0,0-.89.61,4.51,4.51,0,0,0,0,3.46,1,1,0,0,0,.89.61H5.86a.91.91,0,0,0,0,.17A2.34,2.34,0,0,0,4.21,24.4V39.83A1.12,1.12,0,0,0,5.33,41H11a1.13,1.13,0,0,0,1.13-1.12V37.12H13l2-4.74a.6.6,0,0,1,.55-.37H26.93v2.66H16.56a1,1,0,0,0,0,2H26.93V49a1,1,0,0,0,2,0V1A1,1,0,0,0,27.93,0ZM8.85,29V25.87h6.86l2,3.16Zm1-7,4-9.64s2.71-.69,11.2-.69l1.93,0V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.46,16.48a1,1,0,0,0-1.38.31L39,31.27l-5.54-3.69a1,1,0,1,0-1.11,1.66l6.4,4.27a1,1,0,0,0,.56.17.76.76,0,0,0,.21,0,1,1,0,0,0,.63-.44l9.6-15.36A1,1,0,0,0,49.46,16.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleConditionReport);
export default __webpack_public_path__ + "static/media/VehicleConditionReport.5ab75abd.svg";
export { ForwardRef as ReactComponent };